import { PaymentFeeType } from './hpfApi';
import { PaymentPlanType } from './paymentPlanType';
import { Installment } from './installment';
import { Recurring } from './recurring';

export class PaymentPlanSettings {
	paymentPlanType: PaymentPlanType;
	paymentFeeType?: PaymentFeeType;
	installment?: Installment;
	recurring?: Recurring;
	accountId?: string;
	endDate?: Date;

	constructor() {
		this.paymentPlanType = PaymentPlanType.NotSet;
	}

	isPaymentPlan(): boolean {
		return this.paymentPlanType !== PaymentPlanType.NotSet;
	}

	isInstallmentPlan(): boolean {
		return this.isPaymentPlan() && this.paymentPlanType === PaymentPlanType.Installment;
	}

	isRecurringPlan(): boolean {
		return this.isPaymentPlan() && this.paymentPlanType === PaymentPlanType.Recurring;
	}
}
